/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Cancelling1Inputs */

const zh_organizationsettings_cancelling1 = /** @type {(inputs: Organizationsettings_Cancelling1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消中...`)
};

const en_organizationsettings_cancelling1 = /** @type {(inputs: Organizationsettings_Cancelling1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelling...`)
};

const es_organizationsettings_cancelling1 = /** @type {(inputs: Organizationsettings_Cancelling1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelando...`)
};

/**
* | output |
* | --- |
* | "Cancelling..." |
*
* @param {Organizationsettings_Cancelling1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_cancelling1 = /** @type {((inputs?: Organizationsettings_Cancelling1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Cancelling1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_cancelling1(inputs)
	if (locale === "en") return en_organizationsettings_cancelling1(inputs)
	return es_organizationsettings_cancelling1(inputs)
});
export { organizationsettings_cancelling1 as "organizationSettings_cancelling" }